import axios from "axios";
import authHeader from "@/services/auth/AuthHeader";

class FeedbackService {
    /** @param payload {message, kind, route, appVersion, userAgent, lastError, locationId} */
    send(payload){
        let basicAuth = authHeader();
        return axios.post('/api/feedback/sendFeedback', payload, { headers: basicAuth });
    }
}

export default new FeedbackService();
